import * as fieldTypes from '../../../../../../constants/FieldTypes';
import {checkAndUpdateFieldHiddenStatus} from '../../../actions/Packages';
import {splitField} from './Field';

export function updateFieldsHiddenStatus(collection, packagesIds?) {
    const {fields} = collection;
    for (const field of fields) {
        if (field.collection.hasChildren) {
            updateFieldsHiddenStatus(field.collection, packagesIds);
            if (field.collection.firstHiddenIdx === 0 && field.type === fieldTypes.TAB) {
                if (!field.hidden) {
                    field.setHide(true);
                }
            } else {
                if (field.hidden) {
                    field.setHide(false);
                }
            }
        } else {
            checkAndUpdateFieldHiddenStatus(field, packagesIds);
            if (field.mergedField) {
                checkAndUpdateFieldHiddenStatus(field.mergedField, packagesIds);
                if (field.hidden !== field.mergedField.hidden) {
                    splitField(field);
                }
            }
        }
    }
    collection.sortHidden();
}
